import { HUB_CHANNEL_TYPE_QUERY_PARAM, HUB_TAB_QUERY_PARAM } from "@/dashboard/lib/hub/tab";
import { HubTab } from "@/dashboard/types/hub";

const SELF_SERVE_SETUP_BASE = "/setup";

export const SELF_SERVE_SETUP_ROUTES = {
  BASE: SELF_SERVE_SETUP_BASE,
  CALL_SCORING: `${SELF_SERVE_SETUP_BASE}/call-scoring`,
  AWAITING_PLATFORM: `${SELF_SERVE_SETUP_BASE}/awaiting-platform`,
} as const;

export const DASHBOARD_ROUTES = {
  AGENT: "/dashboard/agent",
  ANALYTICS: "/dashboard/analytics",
  ANALYTICS_INBOUND: "/dashboard/analytics/inbound",
  ANALYTICS_CAMPAIGNS: "/dashboard/analytics/campaigns",
  ANALYTICS_EXPLORER: "/dashboard/analytics/explorer",
  ANALYTICS_OPERATIONAL: "/dashboard/analytics/operational",
  CALL_AUDIT: "/dashboard/call-audit",
  PRICING: "/dashboard/pricing",
  CALL_SCORING: "/dashboard/call-scoring/review",
  CALL_SCORING_LEADERBOARD: "/dashboard/call-scoring/leaderboard",
  CALL_SCORING_ALL_CALLS: "/dashboard/call-scoring/all-calls",
  CALL_SCORING_TEAM: "/dashboard/settings/team",
  CALL_SCORING_USER: "/dashboard/call-scoring/user",
  UTILIZATION: "/dashboard/utilization",
  UTILIZATION_MANAGEMENT: "/dashboard/utilization/management",
  UTILIZATION_BOARD: "/dashboard/utilization/board",
  UTILIZATION_INSIGHTS: "/dashboard/utilization/insights",
  PERFORMANCE_ATLAS: "/dashboard/performance-atlas",
  PHONE_SYSTEM: "/dashboard/phone-system",
  PHONE_SYSTEM_NUMBERS: "/dashboard/phone-system/numbers",
  PHONE_SYSTEM_TRACKING_SOURCES: "/dashboard/phone-system/tracking-sources",
  PHONE_SYSTEM_ROUTING_PLANS: "/dashboard/phone-system/routing-plans",
  PHONE_SYSTEM_CALLS: "/dashboard/phone-system/calls",
  PHONE_SYSTEM_MARKETING: "/dashboard/phone-system/marketing",
  PHONE_SYSTEM_LIVE: "/dashboard/phone-system/live",
  PHONE_SYSTEM_WALLBOARD: "/dashboard/phone-system/live/wallboard",
  PHONE_SYSTEM_QUEUES: "/dashboard/phone-system/queues",
  PHONE_SYSTEM_AGENTS: "/dashboard/phone-system/agents",
  PHONE_SYSTEM_SKILLS: "/dashboard/phone-system/skills",
  PHONE_SYSTEM_REASON_CODES: "/dashboard/phone-system/reason-codes",
  PHONE_SYSTEM_REPORTS: "/dashboard/phone-system/reports",
  PHONE_SYSTEM_CALLBACKS: "/dashboard/phone-system/callbacks",
  UTILIZATION_OPPORTUNITY_ASSIGNMENT: "/dashboard/utilization/opportunity-assignment",
  SCHEDULE_OPTIMIZATION: "/dashboard/schedule-optimization",
  DASHBOARD: "/dashboard",
  EMERGENCY: "/dashboard/emergency",
  EMERGENCY_CASES: "/dashboard/emergency/cases",
  EMERGENCY_MANAGE: "/dashboard/emergency/manage",
  HUB_ALL: `/dashboard/hub?${HUB_TAB_QUERY_PARAM}=${HubTab.ALL}`,
  HUB_FLAGGED: `/dashboard/hub?${HUB_TAB_QUERY_PARAM}=${HubTab.FLAGGED}`,
  HUB_NEW_CUSTOMER: "/dashboard/hub/new-customer",
  HUB_RESOLVED: `/dashboard/hub?${HUB_TAB_QUERY_PARAM}=${HubTab.RESOLVED}`,
  HUB_TRANSFERRED: `/dashboard/hub?${HUB_TAB_QUERY_PARAM}=${HubTab.TRANSFERRED}`,
  HUB_TRANSFERRED_INTERNAL: `/dashboard/hub?${HUB_TAB_QUERY_PARAM}=${HubTab.TRANSFERRED_INTERNAL}`,
  HUB_POTENTIAL_CALLBACK: `/dashboard/hub?${HUB_TAB_QUERY_PARAM}=${HubTab.POTENTIAL_CALLBACK}`,
  HUB: `/dashboard/hub`,
  MARKETING: "/dashboard/marketing",
  MARKETING_CAMPAIGNS: "/dashboard/marketing/campaigns",
  MARKETING_CAMPAIGNS_ALL_BRANDS: "/dashboard/marketing/campaigns/all-brands",
  MARKETING_OUTBOUNDS: "/dashboard/marketing/outbounds",
  MARKETING_CAMPAIGNS_CREATE: "/dashboard/marketing/campaigns/create",
  MARKETING_CAMPAIGNS_BUILDER: "/dashboard/marketing/campaigns/create/builder",
  MARKETING_CAMPAIGNS_FROM_TEMPLATE: "/dashboard/marketing/campaigns/create/from-template",
  MARKETING_EVENT_TRIGGERS_CREATE: "/dashboard/marketing/event-triggers/create",
  SETTINGS: "/dashboard/settings",
  SETTINGS_TRANSFERS: "/dashboard/settings/transfers",
  SETTINGS_FOLDER_RULES: "/dashboard/settings/folder-rules",
  SETTINGS_FOLDER_RULES_NEW: "/dashboard/settings/folder-rules/new",
  SETTINGS_FOLDER_RULES_PREVIEW: "/dashboard/settings/folder-rules/preview",
  SETTINGS_HOURS: "/dashboard/settings/hours",
  SETTINGS_HOLIDAY: "/dashboard/settings/holiday",
  SETTINGS_MEMBERS: "/dashboard/settings/members",
  SETTINGS_TECHNICIANS: "/dashboard/settings/technicians",
  SETTINGS_UTILIZATION: "/dashboard/settings/utilization",
  SETTINGS_ARRIVAL_WINDOWS: "/dashboard/settings/arrival-windows",
  SETTINGS_EXPORT_REPORTS: "/dashboard/settings/export-reports",
  SETTINGS_AUDIT_TRAIL: "/dashboard/settings/audit-trail",
  SETTINGS_SHIFTS: "/dashboard/settings/shifts",
  SETTINGS_ZIPCODES: "/dashboard/settings/zipcodes",
  SETTINGS_SKILLS: "/dashboard/settings/skills",
  SETTINGS_TIME_OFF: "/dashboard/settings/time-off",
  SETTINGS_NOTIFICATIONS: "/dashboard/settings/notifications",
  SETTINGS_NOTIFICATIONS_SYSTEM_STATUS: "/dashboard/settings/notifications/system-status",
  CALL_RUBRIC_GROUPS: "/dashboard/settings/rubrics",
  GREENHOUSE: "/dashboard/greenhouse",
  GREENHOUSE_QUEUE: "/dashboard/greenhouse/queue",
  GREENHOUSE_OWNERS: "/dashboard/greenhouse/owners",
  GREENHOUSE_CATALOG: "/dashboard/greenhouse/catalog",
  GREENHOUSE_MEMBERS: "/dashboard/greenhouse/members",
  GREENHOUSE_SETTINGS: "/dashboard/greenhouse/settings",
  GREENHOUSE_CUSTOMER: "/dashboard/greenhouse/customer",
  GREENHOUSE_OPPORTUNITY: "/dashboard/greenhouse/opportunity",
  GREENHOUSE_VOIDED: "/dashboard/greenhouse/voided",
  GREENHOUSE_TASKS: "/dashboard/greenhouse/tasks",
  GREENHOUSE_MAP: "/dashboard/greenhouse/map",
  GREENHOUSE_CREATE: "/dashboard/greenhouse/create",
  SETTINGS_ACCOUNT: "/dashboard/settings/account",
  SETTINGS_BILLING: "/dashboard/settings/billing",
  REPORT_LOG: "/dashboard/settings/report-log",
  ANONYMOUS_CALLERS: "/dashboard/settings/anonymous-callers",
  MEMBERS: "/dashboard/members",
  SIGN_IN: "/sign-in",
  STATUS: "/dashboard/status",
  SWITCH_TENANT: "/dashboard/switch-tenant",
} as const;

export const DYNAMIC_DASHBOARD_ROUTES = {
  CALL_SCORING_USER: (userId: string) => `${DASHBOARD_ROUTES.CALL_SCORING_USER}/${userId}`,
  CALL_RUBRIC_GROUP: (groupId: string) => `${DASHBOARD_ROUTES.CALL_RUBRIC_GROUPS}/${groupId}`,
  CALL_RUBRIC_GROUP_RUBRIC: (groupId: string, rubricId: string) =>
    `${DASHBOARD_ROUTES.CALL_RUBRIC_GROUPS}/${groupId}/rubrics/${rubricId}`,
  CALL_RUBRIC_GROUP_NEW_RUBRIC: (groupId: string, classification: "lead" | "non-lead") =>
    `${DASHBOARD_ROUTES.CALL_RUBRIC_GROUPS}/${groupId}/rubrics/new?classification=${classification}`,
  GREENHOUSE_CUSTOMER: (endUserId: string) =>
    `${DASHBOARD_ROUTES.GREENHOUSE_CUSTOMER}/${endUserId}`,
  GREENHOUSE_OPPORTUNITY: (opportunityId: string) =>
    `${DASHBOARD_ROUTES.GREENHOUSE_OPPORTUNITY}/${opportunityId}`,
  PHONE_SYSTEM_ROUTING_PLAN: (planId: string) =>
    `${DASHBOARD_ROUTES.PHONE_SYSTEM_ROUTING_PLANS}/${planId}`,
  PHONE_SYSTEM_CALL: (callId: string) => `${DASHBOARD_ROUTES.PHONE_SYSTEM_CALLS}/${callId}`,
  PHONE_SYSTEM_QUEUE: (queueId: string) => `${DASHBOARD_ROUTES.PHONE_SYSTEM_QUEUES}/${queueId}`,
  PHONE_SYSTEM_AGENT: (agentId: string) => `${DASHBOARD_ROUTES.PHONE_SYSTEM_AGENTS}/${agentId}`,
  HUB: (tab: HubTab) => `/dashboard/hub?${HUB_TAB_QUERY_PARAM}=${tab}`,
  SETTINGS_FOLDER_RULES_EDIT: (folderId: string) =>
    `${DASHBOARD_ROUTES.SETTINGS_FOLDER_RULES}/${folderId}`,
  HUB_CUSTOMER: (customerId: string, tab?: HubTab, channelType?: "messages" | "calls") => {
    const params = new URLSearchParams();
    if (tab) {
      params.set(HUB_TAB_QUERY_PARAM, tab);
    }
    if (channelType) {
      params.set(HUB_CHANNEL_TYPE_QUERY_PARAM, channelType);
    }

    const queryString = params.toString();
    return `/dashboard/hub/${customerId}${queryString ? `?${queryString}` : ""}`;
  },
  MARKETING_CAMPAIGN: (campaignId: string) =>
    `${DASHBOARD_ROUTES.MARKETING_CAMPAIGNS}/${campaignId}`,
  MARKETING_OUTBOUNDS_END_USER: (endUserId: string) =>
    `${DASHBOARD_ROUTES.MARKETING_OUTBOUNDS}/${endUserId}`,
  // Back-link from the outbound trail into a campaign's audience table, pre-filtered (by full phone,
  // which the audience search matches digit-normalized) and highlighting the specific member row.
  MARKETING_CAMPAIGN_MEMBER: (campaignId: string, phone: string, audienceMemberId: string) =>
    `${DASHBOARD_ROUTES.MARKETING_CAMPAIGNS}/${campaignId}?search=${encodeURIComponent(
      phone
    )}&highlight=${audienceMemberId}`,
} as const;

export const MULTI_TENANT_VIEW_ROUTE_WHITELIST = [
  DASHBOARD_ROUTES.HUB,
  DASHBOARD_ROUTES.CALL_AUDIT,
  DASHBOARD_ROUTES.ANALYTICS,
  DASHBOARD_ROUTES.GREENHOUSE,
  DASHBOARD_ROUTES.MARKETING,
  DASHBOARD_ROUTES.REPORT_LOG,
  DASHBOARD_ROUTES.ANONYMOUS_CALLERS,
  DASHBOARD_ROUTES.STATUS,
  DASHBOARD_ROUTES.UTILIZATION_INSIGHTS,
  DASHBOARD_ROUTES.SETTINGS_TECHNICIANS,
];

export function isMultiTenantViewRouteAllowed(
  pathname: string,
  additionalRoutes: readonly string[] = []
): boolean {
  if (pathname === DASHBOARD_ROUTES.SETTINGS) {
    return true;
  }
  return [...MULTI_TENANT_VIEW_ROUTE_WHITELIST, ...additionalRoutes].some(route =>
    pathname.startsWith(route)
  );
}

export const ONBOARDING_ROUTES = {
  CALL_SCORING: "/onboarding/call-scoring/review",
  CALL_SCORING_LEADERBOARD: "/onboarding/call-scoring/leaderboard",
  CALL_SCORING_ALL_CALLS: "/onboarding/call-scoring/all-calls",
  CALL_SCORING_USER: "/onboarding/call-scoring/user",
  CALL_RUBRIC_GROUPS: "/onboarding/settings/rubrics",
  CALL_SCORING_TEAM: "/onboarding/settings/team",
  REPORT_LOG: "/onboarding/settings/report-log",
} as const;

export const DYNAMIC_ONBOARDING_ROUTES = {
  CALL_SCORING_DETAIL: "/onboarding/call-scoring/review/details",
  CALL_SCORING_USER: (_userId: string) => "/onboarding/call-scoring/user/details",
  CALL_RUBRIC_GROUP: (_groupId: string) => "/onboarding/settings/rubrics/group",
  CALL_RUBRIC_GROUP_RUBRIC: (_groupId: string, _rubricId: string) =>
    "/onboarding/settings/rubrics/group/rubrics/editor",
  CALL_RUBRIC_GROUP_NEW_RUBRIC: (_groupId: string, _classification: "lead" | "non-lead") =>
    "/onboarding/settings/rubrics/group/rubrics/editor",
} as const;

type RoutePrefix = "/dashboard" | "/onboarding" | "/demo";

export function getDynamicRubricRoutes(prefix: RoutePrefix) {
  // /demo doesn't have its own rubric routes yet, so fall back to dashboard's.
  return prefix === "/onboarding" ? DYNAMIC_ONBOARDING_ROUTES : DYNAMIC_DASHBOARD_ROUTES;
}

export const ENTERPRISE_ROUTES = {
  // Base prefix covering every call-scoring page; the multi-tenant guard allowlists this prefix
  // (not CALL_SCORING, which is the /review tab) so the account view's tabs + drilldown all pass.
  CALL_SCORING_BASE: "/dashboard/enterprise/call-scoring",
  CALL_SCORING: "/dashboard/enterprise/call-scoring/review",
  CALL_SCORING_LEADERBOARD: "/dashboard/enterprise/call-scoring/leaderboard",
  CALL_SCORING_ALL_CALLS: "/dashboard/enterprise/call-scoring/all-calls",
  CALL_SCORING_USER: "/dashboard/enterprise/call-scoring/user",
  // Account (cross-brand) CSR drilldown: `[id]` is a cxr_group id, aggregated across the account.
  CALL_SCORING_ACCOUNT_USER: "/dashboard/enterprise/call-scoring/account-user",
  CALL_SCORING_TEAM: "/dashboard/enterprise/call-scoring/team",
  CALL_SCORING_MY_SCORES: "/dashboard/enterprise/call-scoring/my-scores",
  CALL_RUBRIC_GROUPS: "/dashboard/enterprise/call-rubric-groups",
} as const;

export const DYNAMIC_ENTERPRISE_ROUTES = {
  CALL_SCORING_USER: (cxrUserId: string) => `${ENTERPRISE_ROUTES.CALL_SCORING_USER}/${cxrUserId}`,
  CALL_SCORING_ACCOUNT_USER: (cxrGroupId: string) =>
    `${ENTERPRISE_ROUTES.CALL_SCORING_ACCOUNT_USER}/${cxrGroupId}`,
} as const;

export const ENTERPRISE_RUBRIC_ROUTES = ENTERPRISE_ROUTES;

export const DYNAMIC_ENTERPRISE_RUBRIC_ROUTES = {
  CALL_RUBRIC_GROUP: (groupId: string) =>
    `${ENTERPRISE_RUBRIC_ROUTES.CALL_RUBRIC_GROUPS}/${groupId}`,
  CALL_RUBRIC_GROUP_RUBRIC: (groupId: string, rubricId: string) =>
    `${ENTERPRISE_RUBRIC_ROUTES.CALL_RUBRIC_GROUPS}/${groupId}/rubrics/${rubricId}`,
  CALL_RUBRIC_GROUP_NEW_RUBRIC: (groupId: string, classification: "lead" | "non-lead") =>
    `${ENTERPRISE_RUBRIC_ROUTES.CALL_RUBRIC_GROUPS}/${groupId}/rubrics/new?classification=${classification}`,
} as const;

export const SELF_SERVE_SETTINGS_PREFIXES = [
  DASHBOARD_ROUTES.CALL_RUBRIC_GROUPS,
  DASHBOARD_ROUTES.CALL_SCORING_TEAM,
  DASHBOARD_ROUTES.REPORT_LOG,
  DASHBOARD_ROUTES.SETTINGS_ACCOUNT,
  DASHBOARD_ROUTES.SETTINGS_BILLING,
];

export function isSelfServeSettingsRoute(path: string): boolean {
  return SELF_SERVE_SETTINGS_PREFIXES.some(prefix => path.startsWith(prefix));
}

export const SELF_SERVE_ROUTE_WHITELIST = [
  DASHBOARD_ROUTES.CALL_SCORING,
  DASHBOARD_ROUTES.CALL_SCORING_LEADERBOARD,
  DASHBOARD_ROUTES.CALL_SCORING_ALL_CALLS,
  DASHBOARD_ROUTES.CALL_SCORING_TEAM,
  DASHBOARD_ROUTES.CALL_SCORING_USER,
  DASHBOARD_ROUTES.CALL_RUBRIC_GROUPS,
  DASHBOARD_ROUTES.REPORT_LOG,
  DASHBOARD_ROUTES.SETTINGS_ACCOUNT,
  DASHBOARD_ROUTES.SETTINGS_BILLING,
  SELF_SERVE_SETUP_ROUTES.CALL_SCORING,
  SELF_SERVE_SETUP_ROUTES.AWAITING_PLATFORM,
];
